import { Badge } from "components/Theme/badge";
import type { JobStatus } from "kubb";
import type { Status } from "kubb";
import type React from "react";

export default function AssetRegisterStatusLabel(props: {
  status: Status | JobStatus;
  className?: string;
  displayActive?: boolean;
}): React.ReactElement {
  const { className, status, displayActive = false } = props;

  const activeElement = (
    <>
      {" "}
      {displayActive && (
        <Badge color={"success"} className={className}>
          Active
        </Badge>
      )}
    </>
  );
  switch (status) {
    case "ACTIVE":
      return activeElement;
    case "active":
      return activeElement;
    case "DELETED":
      return (
        <Badge color={"danger"} className={className}>
          Deleted
        </Badge>
      );
    case "disabled":
      return (
        <Badge color={"danger"} className={className}>
          Disabled
        </Badge>
      );
    default:
      return <></>;
  }
}
